import { identifyUser as identifyUserLogRocket } from './logRocket';

const setTrackUser = ({ userIdentifier, additionalInfo }) => {
  if (typeof window.clarity === 'function') {
    window.clarity('identify', userIdentifier);
    window.clarity('set', 'additionalInfo', JSON.stringify(additionalInfo));
  }

  identifyUserLogRocket({ userIdentifier, additionalInfo });
};

export { setTrackUser };
